var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencilIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.07706 14.923H2.11356L12.8271 4.2125L11.7876 3.173L1.07706 13.8895V14.923ZM0.153809 15.8462V13.4962L13.2116 0.412497C13.3037 0.329997 13.4055 0.266246 13.5168 0.221246C13.628 0.176246 13.7466 0.153748 13.8728 0.153748C13.9966 0.153748 14.1166 0.174414 14.2326 0.215747C14.3487 0.257247 14.46 0.324746 14.5663 0.418246L15.5876 1.44225C15.6812 1.54041 15.7477 1.64741 15.7871 1.76325C15.8266 1.87908 15.8463 1.996 15.8463 2.114C15.8463 2.24 15.8248 2.36083 15.7818 2.4765C15.739 2.59216 15.6736 2.6945 15.5858 2.7835L2.50381 15.8462H0.153809ZM12.2991 3.701L11.7876 3.173L12.8271 4.2125L12.2991 3.701Z",
    fill: "#3D3D3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilIcon);
export default __webpack_public_path__ + "static/media/pencil-icon.c8de3be01115a1d7b0378d1dc4fb5b86.svg";
export { ForwardRef as ReactComponent };